import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface BookingItem {
  slug: string;
  name: string;
  price: number;
  unit: "kg" | "pz";
  image: string;
}

interface BookingState {
  items: BookingItem[];
  add: (item: BookingItem) => void;
  remove: (slug: string) => void;
  clear: () => void;
}

export const useBooking = create<BookingState>()(
  persist(
    (set) => ({
      items: [],
      add: (item) =>
        set((s) => {
          if (s.items.some((i) => i.slug === item.slug)) return s;
          return { items: [...s.items, item] };
        }),
      remove: (slug) =>
        set((s) => ({ items: s.items.filter((i) => i.slug !== slug) })),
      clear: () => set({ items: [] }),
    }),
    {
      name: "bottega-richieste-v2",
      // Drop qty from any pre-v2 persisted items to keep the store safe
      migrate: (state: unknown) => {
        const s = state as { items?: Array<Record<string, unknown>> } | undefined;
        if (!s?.items) return s as never;
        return {
          items: s.items.map(({ qty: _qty, ...rest }) => rest),
        } as never;
      },
      version: 2,
    }
  )
);

export const useBookingCount = () =>
  useBooking((s) => s.items.length);
